
export function setAddress (state, data) {
    if (data) {
        state.address = { ...data }
    } else {
        state.address = null
    }
}

export function setClient (state, data) {
    if (data) {
        state.client = { ...data }
    } else {
        state.client = null
    }
}